import gql from 'graphql-tag'

export const DELETION_REQUEST_FRAGMENT = gql`
fragment DeletionRequestFragment on DeletionRequest {
  id
  entityType
  entityId
  entityName
  requestedBy {
    id
    name
    email
  }
  requestedAt
  scheduledAt
  status
  cancelledBy {
    id
    name
    email
  }
  cancelledAt
  cancellationReason
  executedAt
  errorMessage
  deletionLog
}
`
